import React from "react";
import { useTranslation } from "react-i18next";
import {
  Box,
  List,
  ListItem,
  ListItemText,
  Tooltip,
  Typography,
} from "@mui/material";

type MyHrPageMenuProps = {
  step: number;
  onChangeStep: (step: number) => void;
};

export const MyHrPageMenu = ({ step, onChangeStep }: MyHrPageMenuProps) => {
  const { t } = useTranslation();

  const getColor = (step: number, activeStep: number) => {
    if (step === activeStep) {
      return "#fff";
    }
    if (step > activeStep) {
      return "#212121";
    }
    return "#919699";
  };

  return (
    <Box width="240px" minWidth="240px" paddingTop="16px">
      <List style={{ padding: "0px" }}>
        <ListItem
          style={{
            padding: "0px 14px 0px 14px",
            height: "40px",
            backgroundColor: step === 1 ? "#cc0033" : "transparent",
            clipPath:
              step === 1 ? "polygon(0 0, 94% 0, 100% 100%, 0% 100%)" : "",
            borderLeft: step > 1 ? "4px solid #cc0033" : "",
            cursor: step > 1 ? "pointer" : "auto",
          }}
          onClick={() => {
            if (step > 1) {
              onChangeStep(1);
            }
          }}
        >
          <ListItemText
            style={{
              fontSize: "14px",
              letterSpacing: "0.25px",
              cursor: "pointer",
            }}
          >
            <Tooltip title={t("MY_HR_SELECT_EMPLOYEE")} placement="right">
              <Typography
                variant="body1"
                color={getColor(step, 1)}
                noWrap={true}
              >
                1. {t("MY_HR_SELECT_EMPLOYEE")}
              </Typography>
            </Tooltip>
          </ListItemText>
        </ListItem>
        <ListItem
          style={{
            padding: "0px 14px 0px 14px",
            height: "40px",
            backgroundColor: step === 2 ? "#cc0033" : "transparent",
            clipPath:
              step === 2 ? "polygon(0 0, 94% 0, 100% 100%, 0% 100%)" : "",
            borderLeft: step > 1 ? "4px solid #cc0033" : "",
            cursor: step > 1 ? "pointer" : "auto",
          }}
          onClick={() => {
            if (step > 2) {
              onChangeStep(2);
            }
          }}
        >
          <ListItemText
            style={{
              fontSize: "14px",
              letterSpacing: "0.25px",
            }}
          >
            <Typography variant="body1" color={getColor(step, 2)}>
              2. {t("MY_HR_PERMISSION")}
            </Typography>
          </ListItemText>
        </ListItem>
        <ListItem
          style={{
            padding: "0px 14px 0px 14px",
            height: "40px",
            backgroundColor: step === 3 ? "#cc0033" : "transparent",
            clipPath:
              step === 3 ? "polygon(0 0, 94% 0, 100% 100%, 0% 100%)" : "",
          }}
        >
          <ListItemText
            style={{
              fontSize: "14px",
              letterSpacing: "0.25px",
            }}
          >
            <Typography variant="body1" color={getColor(step, 3)}>
              3. {t("OC_ROLE")}
            </Typography>
          </ListItemText>
        </ListItem>
      </List>
    </Box>
  );
};

export default MyHrPageMenu;
